import { createIcon } from "@chakra-ui/react";

const SendIcon = createIcon({
  displayName: "SendIcon",
  viewBox: "0 0 24 24",
  path: <path d="m2 21l21-9L2 3v7l15 2l-15 2v7Z" fill="currentColor" />,
});

export default SendIcon;
